/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { task } from 'ember-concurrency';
import { inject as service } from '@ember/service';

import DS from 'ember-data';
import EmberObject from '@ember/object';
import IdentityModel from 'cio/models/identity';
import AlertsService from 'cio/services/alerts';

type FormValues = EmberObject & {
  name: string;
  email: string;
};

interface AddFromAddressArgs {
  domainName: string;
  onSave: (identity: IdentityModel) => Promise<unknown>;
  onDiscard: () => unknown;
}

export default class AddFromAddress extends Component<AddFromAddressArgs> {
  @service store!: DS.Store;
  @service alerts!: AlertsService;

  saveIdentityTask = task(async ({ name, email }: FormValues) => {
    let identity = this.store.createRecord('identity', {
      name,
      email,
      templateType: 'email',
    });

    try {
      await identity.save();

      if (this.args.onSave) {
        await this.args.onSave(identity);
      }

      this.alerts.success('identity.save.success', 'From address created');
    } catch {
      identity.rollbackAttributes();
      this.alerts.error('identity.save.failure', 'Unable to create from address');
    }
  });
}
